// extracted by mini-css-extract-plugin
module.exports = {"container":"languageFooter-module--container--3nhel","content":"languageFooter-module--content--4cYH3","language":"languageFooter-module--language--1Cvnw"};